import React, { memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { IgnoreInput } from '../../select/ignore-input'
import { useKayleRules } from '@app/data/formatters/use-kayle-rules'
import { InfoBlock } from '../../cells'

export const IgnoreRulesBoxWrapperMock = ({
  websiteIgnore,
  runners,
  lang,
  activeSubscription,
  noInfoBlock,
}: {
  url?: string
  domain?: string
  activeSubscription?: boolean
  demo?: boolean
  runners?: string[]
  lang?: string
  websiteIgnore?: string[]
  noInfoBlock?: boolean
}) => {
  const { t } = useTranslation('dashboard')

  const { ignore, setIgnore, ignoreList, onLoadRulesEvent } = useKayleRules({
    runners,
    lang: lang || 'en',
    websiteIgnore,
  })

  if (noInfoBlock) {
    return (
      <IgnoreInput
        t={t}
        onLoadRulesEvent={onLoadRulesEvent}
        ignoreList={ignoreList}
        setIgnore={setIgnore}
        ignore={ignore}
        disabled={!activeSubscription}
      />
    )
  }
  return (
    <InfoBlock>
      <IgnoreInput
        t={t}
        onLoadRulesEvent={onLoadRulesEvent}
        ignoreList={ignoreList}
        setIgnore={setIgnore}
        ignore={ignore}
        disabled={!activeSubscription}
      />
    </InfoBlock>
  )
}

export const IgnoreRulesBoxMock = memo(IgnoreRulesBoxWrapperMock)
